import { Component, Event, EventEmitter, h } from '@stencil/core';
import store from '../../../helpers/store';
import Events from '../../../helpers/Events';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import logoOntrace from '../../../assets/logo-ontrace.svg';
import { db } from '../../../helpers/db';

@Component({
  tag: 'end-redirect',
  styleUrl: 'end-redirect.css',
  shadow: false,
})
export class EndRedirect {
  private translations: TranslationValues;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  constructor() {}

  async componentWillLoad() {
    this.translations = await Translations.getValues();
  }

  async componentDidLoad() {
    await db.ectdata.delete(store.requestId);

    Events.flowCompleted();
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-2 w-100">
          <h1 class="text-center mb-1">{this.translations.CompleteValues.Title}</h1>
          <img class="w-100 mb-1" src="https://ekyc.blob.core.windows.net/$web/process_complete.gif" />
          <h1 class="text-center">{this.translations.CompleteValues.Message}</h1>
          <p class="text-center">{store.requestId}</p>

          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
